import { getProductCategories } from 'src/app/utils/analytics/utils/getProductCategories';

export default ({ adBudgetPurchased = 'jobAd' }) => ({
  productCategories: getProductCategories(adBudgetPurchased),
  productEvents: ['add'],
  productQuantities: 1,
  objectInteraction: 'premiumUpsell',
});
